<style lang="less" scoped>
.contian-tendency {
    height: 500px;
    width: 100;
    .button-group {
        text-align: right;
    }
      .one-chart {
        height:500px;
        width: 100%;
        .test {
          height: 100%;
          width: 100%;
          div {
            height: 100%;
            width: 100%;
          }
        }
    }
}
</style>
<template>
  <div class="contian-tendency">
    <Spin
      v-if="loading.getTendencyLoading"
      size="large"
      fix
    />
    <div class="button-group">
      <IconMark />
      <DatePicker
        v-model="params.month"
        :clearable="false"
        type="month"
        format="yyyy-MM"
        confirm
        placeholder="请选择月份"
        style="width: 200px;padding:10px;"
        @on-ok="timeSelected"
      />
      <Select
        v-model="params.team_id"
        style="width:200px;padding:10px 0;"
        @on-change="changeItem"
      >
        <Option
          v-for="item in teamsList"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </Option>
      </Select> 
    </div>
    <div
      :style="{ height:overview_height+'px' }"
      class="one-chart"
    >
      <div
        ref="oldNew"
        class="test"
      />
    </div>
    <div
      :style="{ height:overview_height+'px',
                'margin-top':50+'px' }"
      class="one-chart"
    >
      <div
        ref="lowHigh"
        class="test"
      />
      <p
        style="display: inline-block;margin: 10px 0px 20px;"
      >
        备注：上图的用户数按照不同价格区间去重；如果一个用户在同一天既买了低价课，又买了高价课，则会算作两次购买。
      </p>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  import { mapState, mapActions, mapMutations } from 'vuex'
  import { generate_old_new_option, generate_low_high_option } from './tendency_one_fields'
  import IconMark from './IconMark.vue'
  import { NAME_SPACE } from '../constants'
  import { daysNumber } from '../utils'
  export default {
    components: {
      IconMark,
    },
    props: {
      tableHeight: {
        type:Number,
        default: () => 500
      }
    },
    data() {
      return {
        params: {
          month:new Date(),
          team_id: 'all'
        }
      }
    },
    watch: {
      'changeTag.oldAndNewIndex'() {
        this.$nextTick(() => {
          this.setOldNewEchartOption()
          this.setLowHighEchartOption()
        })
      }
    },
    mounted() {
      this.oldNewChart = echarts.init(this.$refs.oldNew, 'walden')
      this.lowHighChart = echarts.init(this.$refs.lowHigh, 'walden')
      this.addEchartsResize([this.oldNewChart.resize, this.lowHighChart.resize]) // 将所有的echart调整注入队列中
    },
    computed: {
      ...mapState(NAME_SPACE, {
        loading:'loading',
        teamList: 'teamList',
        changeTag: 'changeTag',
        tendencyList: 'tendencyList'
      }),
      teamsList() {
        const item = {
          name:'集团整体',
          id: 'all'
        }
        return [item, ...this.teamList].filter(item => item.id !== 24)
      },
      overview_height() {
        return this.tableHeight - 50
      }
    },
    methods: {
      ...mapMutations(NAME_SPACE, [ 
        'addEchartsResize',
        'resizeCall'
      ]),
      ...mapActions(NAME_SPACE, [
        'getTendency',
      ]),
      resizeEchart() {
        this.resizeCall([this.oldNewChart.resize, this.lowHighChart.resize])
      },
      timeSelected() {
        this.getData()
      },
      getData() {
        const params_clone = {...this.params}
        params_clone.month = moment(this.params.month).format('YYYY-MM')
        if (params_clone.team_id === 'all') {
          delete params_clone.team_id
        }
        this.getTendency(params_clone)
      },
      changeItem() {
        this.getData()
      },
      setOldNewEchartOption() {
        let { new_user, old_user } = this.tendencyList
        new_user = new_user || []
        old_user = old_user || []
        // 计算出日期对应值的hash表
        const [ new_user_hash, old_user_hash ] = [new_user, old_user].map(arr => {
          return (arr || []).reduce((total, item) => {
            total[item[0].slice(-2)] = item[1]
            return total
          }, {})
        })
        // 避免两个列表数据不同步的情况
        const date_arr = daysNumber(this.params.month)
        const option = generate_old_new_option()
        option.title.text = '用户构成（新老用户分布）'
        option.xAxis[0].data = date_arr
        option.series[0].data = date_arr.map(key => old_user_hash[key] || 0)
        option.series[1].data = date_arr.map(key => new_user_hash[key] || 0)
        this.oldNewChart.setOption(option);
      },
      setLowHighEchartOption() {
        let { user_high, user_middle, user_low } = this.tendencyList
        // 对日期进行计算
        user_high = user_high || []
        user_middle = user_middle || []
        user_low = user_low || []
        // 计算出日期对应值的hash表
        const [ user_high_hash, user_middle_hash, user_low_hash ] = [user_high, user_middle, user_low].map(arr => {
          return (arr || []).reduce((total, item) => {
            total[item[0].slice(-2)] = item[1]
            return total
          }, {})
        })
        const date_arr = daysNumber(this.params.month)
        const option = generate_low_high_option()
        option.title.text = '用户构成（价格区间分布）'
        option.xAxis[0].data = date_arr
        option.series[0].data = date_arr.map(key => user_low_hash[key] || 0)
        option.series[1].data = date_arr.map(key => user_middle_hash[key] || 0)
        option.series[2].data = date_arr.map(key => user_high_hash[key] || 0)       
        this.lowHighChart.setOption(option);
      }
    }
  }
</script>
